import type { ADDoc } from '@atlaskit/editor-common/utils/validator';

export const parseMacroOutputAdf = (macroOutput: string): ADDoc | undefined => {
	try {
		if (macroOutput) {
			const parsed = JSON.parse(macroOutput);
			if (parsed.version === 1 && parsed.type === 'doc' && parsed.content) {
				return parsed as ADDoc;
			}
		}
	} catch (e) {
		// do nothing in case of parsing error, which would return `undefined`
	}
};

export const getMacroId = (node: any): any => node?.parameters?.macroMetadata?.macroId?.value;
export const getMacroParam = (node: any, name: string): any =>
	node?.parameters?.macroParams?.[name]?.value;
